import LoadingWave from "./LoadingWave";
import axios from "axios";
import { FaSearch, FaEdit, FaTrash } from "react-icons/fa";
import Select from "react-select";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { REPORTS_API_ROOT } from "./config/api";
export default function StockForm({ user, onLogout, editingRecord }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();
  const role = user?.role;
 const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  const API_BASE = REPORTS_API_ROOT;


  const [isStockFormOpen, setIsStockFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    date: new Date().toISOString().slice(0, 10),
    code: "",
    itemName: "",
    unit: "",
    fromLocation: "",
    toLocation: "",
    quantity: "",
  });

  const [entries, setEntries] = useState([]);
  const [searchDate, setSearchDate] = useState("");
 const [token, setToken] = useState(localStorage.getItem("token"));

  const [searchDoc, setSearchDoc] = useState("");
  const [searchCode, setSearchCode] = useState("");
  const [searchItem, setSearchItem] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [locations, setLocations] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [units, setUnits] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [transferData, setTransferData] = useState([]);
  const [showAddButton, setShowAddButton] = useState(false);
  const [docNo, setDocNo] = useState("");

 const [items, setItems] = useState([]);

const [isDropdownOpen, setIsDropdownOpen] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
const entriesPerPage = 10;
useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

const filteredEntries = entries
  .filter((entry) =>
    (searchDate === "" || entry.date?.split("T")[0].includes(searchDate)) &&
    (searchDoc === "" || entry.docNo?.toString().includes(searchDoc)) &&
    (searchCode === "" || entry.code?.toLowerCase().includes(searchCode.toLowerCase())) &&
    (searchItem === "" || entry.itemName?.toLowerCase().includes(searchItem.toLowerCase()))
  )
  .slice(0, 50);
 useEffect(() => {
  if (formData.code) {
    fetchUnits(formData.code);
  }
}, [formData.code]);

useEffect(() => {
  const fetchInitialEntries = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${API_BASE}/api/transfer/latest123`);
      setEntries(res.data); // only update 'entries'
    } catch (err) {
      console.error("Failed to fetch initial entries:", err);
    } finally {
      setIsLoading(false);
    }
  };

  fetchInitialEntries();
}, []);

const handleLogin = (newToken) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
  };
const handleLogout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("currentUser");
  localStorage.removeItem("username");
  localStorage.removeItem("userRole");
  localStorage.removeItem("permissions");
  localStorage.removeItem("access");
  localStorage.removeItem("loggedUser");
  localStorage.removeItem("isAuthenticated");
  setToken(null);

  if (onLogout) {
    onLogout();
    return;
  }

  navigate("/login");
};

const handleDelete = (index) => {
  const newItems = [...items];  
  newItems.splice(index, 1);   
  setItems(newItems);          
};

const fetchLocations = async () => {
  try {
    const res = await axios.get(`${API_BASE}/api/locations`);

    const formattedLocations = res.data.map((loc) => ({
      value: loc.LOC_DOCNO,
      label: `${loc.LOC_DOCNO} - ${loc.LOC_DESC}`,
    }));

    setLocations(formattedLocations);
  } catch (err) {
    console.error("Error fetching locations:", err);
  }
};

useEffect(() => {
  if (!editingRecord) return;
  if (locations.length === 0) return;

  setFormData(prev => ({
    ...prev,
    fromLocation: locations.find(l => l.value === editingRecord.fromLoc) || null,
    toLocation: locations.find(l => l.value === editingRecord.toLoc) || null
  }));
}, [editingRecord, locations]);


  const fetchUnits = async (code) => {
    try {
      const res = await axios.get(`${API_BASE}/api/units/${code}`);
      setUnits(res.data || []);
    } catch (err) {
      console.error("Error fetching units:", err);
    }
  };

 const fetchItems = useCallback(async () => {
  setIsLoading(true);
  try {
    const res = await axios.get(`${API_BASE}/api/items`);
    setItems(res.data);
    setFilteredItems(res.data);
  } catch (err) {
    console.error("Error fetching items:", err);
  } finally {
    setIsLoading(false);
  }
}, [API_BASE]);

  // Fetch entries (latest 50)
const fetchEntries = useCallback(async (showLoader = true) => {
  if (showLoader) setIsLoading(true);

  try {
    const res = await axios.get(`${API_BASE}/api/transfer/latest123`);
    if (Array.isArray(res.data)) {
      setEntries(res.data);
    }
  } catch (err) {
    console.error("Error fetching entries:", err);
  } finally {
    if (showLoader) setIsLoading(false);
  }
}, []);

useEffect(() => {
  const fetchDocNo = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/transfer/new-docno`);
      setDocNo(String(res.data.docNo));
    } catch (err) {
      console.error("Error fetching docNo:", err);
    }
  };

  fetchDocNo();
}, []);

useEffect(() => {
  const handleResize = () => setIsDesktop(window.innerWidth > 768);
  window.addEventListener("resize", handleResize);
  // set initial correctly
  handleResize();
  return () => window.removeEventListener("resize", handleResize);
}, []);
  // initial load
  useEffect(() => {
  fetchLocations();
}, []);
useEffect(() => {
  fetchNextDocNo();
}, []);

  useEffect(() => {
  const interval = setInterval(() => fetchEntries(false), 1000000);
  return () => clearInterval(interval);
}, [isStockFormOpen, fetchEntries]);

useEffect(() => {
  if (!isDesktop) fetchItems();
}, [isDesktop]);

  // fetch items only when popup opens
  useEffect(() => {
    if (isPopupOpen) fetchItems();
  }, [isPopupOpen]);
const selectItem = (item) => {
  if (!item) return;
  setFormData((prev) => ({
    ...prev,
    code: item.CODE,
    itemName: item.DESCRIPTION,
  }));
  fetchUnits(item.CODE);
  // close popup only on desktop
  if (isDesktop) setIsPopupOpen(false);
};

  const handleSearch = () => {
    const lower = searchText.toLowerCase();
    const filtered = items.filter(
      (item) =>
        item.CODE?.toLowerCase().includes(lower) ||
        item.DESCRIPTION?.toLowerCase().includes(lower)
    );
    setFilteredItems(filtered);
  };

  const handleSelectItem = (item) => {
    setFormData((prev) => ({
      ...prev,
      code: item.CODE,
      itemName: item.DESCRIPTION,
    }));
    fetchUnits(item.CODE);
    setIsPopupOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

const handleEdit = (entry) => {
  console.log("EDIT ENTRY:", entry);   // <-- SEND THIS TO ME

  if (!entry) return;

  const applyEdit = () => {
    setIsEditing(true);
    setEditingId(entry.TSF_DOCNO || entry.docNo);
    setDocNo(entry.TSF_DOCNO || entry.docNo);

    const fromKey = entry.fromLoc || entry.fromLocation || entry.FROM_LOC || entry.FROMLOC;
    const toKey = entry.toLoc || entry.toLocation || entry.TO_LOC || entry.TOLOC;

    console.log("MAP FROM:", fromKey, "MAP TO:", toKey);

    const fromLocObj = locations.find(l => l.value === fromKey) || null;
    const toLocObj = locations.find(l => l.value === toKey) || null;

    console.log("FOUND:", fromLocObj, toLocObj);

    const item = Array.isArray(entry.items) && entry.items.length > 0
      ? entry.items[0]
      : {
          code: entry.code || "",
          itemName: entry.itemName || "",
          unit: entry.unit || "",
          quantity: entry.quantity || "",
        };

    setFormData({
      date: entry.date?.split("T")[0] || "",
      code: item.code,
      itemName: item.itemName,
      unit: item.unit,
      fromLocation: fromLocObj,
      toLocation: toLocObj,
      quantity: item.quantity,
    });

    setSearchText(item.code && item.itemName ? `${item.code} - ${item.itemName}` : "");
  };

  // Location not loaded yet → wait
  if (locations.length === 0) {
    fetchLocations().then(() => applyEdit());
  } else {
    applyEdit();
  }
};


const fetchNextDocNo = async () => {
  try {
    const url = `${API_BASE}/api/transfer/new-docno`;
    console.log("Calling:", url);

    const res = await axios.get(url);

    if (!res.data) {
      console.error("No JSON received:", res);
      return;
    }

    const next =
      res.data.docNo ||
      res.data.nextDocNo ||
      null;

    if (next === null) {
      console.error("Invalid response format:", res.data);
      return;
    }

    setDocNo(String(next));
  } catch (err) {
    console.error("Error in fetchNextDocNo:", err);
  }
};


const handleUpdateSubmit = async () => {
  setIsLoading(true);
  try {
    const response = await fetch(`${API_BASE}/api/transfer/${editingId}`, {
  method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        date: formData.date,
        fromLocation: formData.fromLocation.value,
        toLocation: formData.toLocation.value,
        items: [
          {
            code: formData.code,
            itemName: formData.itemName,
            quantity: formData.quantity,
            unit: formData.unit,
          },
        ],
      }),
    });

    const result = await response.json();

    if (response.ok && result.success) {
  alert("Stock updated successfully!");

  setFormData({
    date: new Date().toISOString().slice(0, 10),
    code: "",
    itemName: "",
    unit: "",
    fromLocation: "",
    toLocation: "",
    quantity: "",
  

  });
  resetForm();
  // 🔥 clear item list
  setItems([]);

  // 🔥 switch back to insert mode
  setIsEditing(false);
  setEditingId(null);
  setEditIndex(null);
  setShowAddButton(true);

  // 🔥 get next auto-increment doc number
  fetch("/api/next-docno")
    .then(res => res.json())
    .then(data => {
      if (data?.nextDocNo) {
        setDocNo(data.nextDocNo);
      }
    })
    .catch(err => console.error("Failed to fetch next docno:", err));

  await fetchEntries();
  await fetchNextDocNo();

} else {
  alert("Failed to update stock: " + (result.error || "unknown error"));
}

  } catch (err) {
    console.error("Error submitting update:", err);
    alert("Failed to update stock. See console for details.");
  } finally {
    setIsLoading(false);
  }
};
useEffect(() => {
  const style = document.createElement("style");
  style.type = "text/css";
  style.id = "stockform-mobile-style";
  style.appendChild(
    document.createTextNode(`
      @media (max-width: 768px) {
     
        .mobile-stack {
          flex-direction: column !important;
          width: 100% !important;
        }
        .popup-overlay,
        .popup-box {
        display: none !important;
  }

  .main-content {
    margin-left: 0 !important;
    padding: 12px !important;
    width: 100% !important;
  }
      }

      @media (max-width: 768px) {
  .main-content,
  .container,
  .table-wrapper {
    transform: none !important;
  }
}
    `)
  );
  document.head.appendChild(style);

  return () => {
    const el = document.getElementById("stockform-mobile-style");
    if (el) el.remove();
  };
}, []);

const runWithLoader = async (fn) => {
  setIsLoading(true);
  try {
    await fn();
  } finally {
    setIsLoading(false);
  }
};


const handleTransferSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  // Validation
  if (!formData.code || !formData.itemName || !formData.fromLocation?.value || 
      !formData.toLocation?.value || !formData.quantity) {
    setIsLoading(false);
    return alert("Please fill in all required fields.");
  }

  const payload = {
  action: isEditing ? "update" : "insert",
  docNo: editingId || undefined,
  date: formData.date,
  fromLocation: formData.fromLocation?.value,
  toLocation: formData.toLocation?.value,
  items: [
    {
      code: formData.code,
      itemName: formData.itemName,
      quantity: Number(formData.quantity),
      unit: formData.unit,
    },
  ],
};

  try {
    // ---------------------- UPDATE MODE ----------------------
    if (isEditing && editingId) {
      const res = await fetch(`${API_BASE}/api/transfer/latest123`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        await fetchEntries();
        alert("Record updated successfully.");

        setIsEditing(false);
        setEditingId(null);

        setFormData({
          date: new Date().toISOString().slice(0, 10),
          code: "",
          itemName: "",
          unit: "",
          fromLocation: "",
          toLocation: "",
          quantity: "",
        });
 try {
      const r = await axios.get(`${API_BASE}/api/transfer/new-docno`);
      console.log("Next DOC NO:", r.data.docNo); // check if returned
      setDocNo(String(r.data.docNo));
    } catch (err) {
      console.error("Failed to fetch new docNo:", err);
    }
        return;
      } else {
        const text = await res.text();
        console.error("UPDATE failed:", res.status, text);
        return alert("Failed to update transfer.");
      }
    }

    // ---------------------- INSERT MODE ----------------------
    const res = await fetch(`${API_BASE}/api/transfer/latest123`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const text = await res.text();
      console.error("Insert failed:", text);
      return alert("Failed to insert transfer.");
    }

    const result = await res.json();
    

    if (result.success) {
      await fetchEntries();
      alert("Transfer inserted successfully!");

      setFormData({
        date: new Date().toISOString().slice(0, 10),
        code: "",
        itemName: "",
        unit: "",
        fromLocation: "",
        toLocation: "",
        quantity: "",
      });

      setIsEditing(false);
      setEditingId(null);
      setEditIndex(null);
      try {
        const r = await axios.get(`${API_BASE}/api/transfer/new-docno`);
        setDocNo(String(r.data.docNo));
      } catch (err) {
        console.error("Failed to refresh docNo:", err);
      }
    }
  } finally {
    setIsLoading(false);
  }
};

const resetForm = async () => {
  // Reset form fields
  setFormData({
    date: new Date().toISOString().slice(0, 10),
    code: "",
    itemName: "",
    unit: "",
    fromLocation: "",
    toLocation: "",
    quantity: "",
  });

  // Reset search
  setSearchText("");           // Clear search input
  setFilteredItems(items);     // Show all items again

  setIsEditing(false);
  setEditingId(null);
  setEditIndex(null);

  // Fetch new docNo
  try {
    const res = await axios.get(`${API_BASE}/api/transfer/new-docno`);
    setDocNo(String(res.data.docNo));
  } catch (err) {
    console.error("Failed to fetch new docNo:", err);
  }
};


const handleTableDelete = async (docNo) => {
  if (!window.confirm(`Are you sure you want to delete DOC NO: ${docNo}?`)) return;

  try {
    setIsDeleting(true);
    await axios.post(`${API_BASE}/api/transfer/${docNo}/delete`);
    await fetchEntries();
    alert("Deleted successfully");

    // Reset form after delete
    resetForm();
  } catch (err) {
    console.error(err);
    alert("Delete failed");
  } finally {
    setIsDeleting(false);
  }
};

const onEditClick = (entry) => {
  if (locations.length === 0) {
    // wait for locations to load first
    fetchLocations().then(() => handleEdit(entry));
  } else {
    handleEdit(entry);
  }
};


 
const indexOfLast = currentPage * entriesPerPage;
const indexOfFirst = indexOfLast - entriesPerPage;
const currentEntries = filteredEntries.slice(indexOfFirst, indexOfLast);
const totalPages = Math.ceil(filteredEntries.length / entriesPerPage);

useEffect(() => {
  if (!isDesktop) {
    const handleClickOutside = (e) => {
      // close only when clicking outside input or dropdown
      if (
        !e.target.closest("#mobile-item-input") &&
        !e.target.closest("#mobile-item-dropdown")
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }
}, [isDesktop]);


const getLocationLabel = (docNo) => {
  const loc = locations.find((l) => l.value === docNo);
  return loc ? loc.label : docNo;
};

 return (
  
  

  <div
  className="mobile-stack stockform-shell"
  style={{
    display: "flex",
    flexDirection: isDesktop ? "row" : "column",
    gap: "16px",
    position: "relative", // needed for absolute positioning
    alignItems: "stretch",
  }}
>
<style>{`
  .stockform-shell {
    height: calc(100vh - 16px);
    padding: 4px;
    overflow: hidden;
    background:
      radial-gradient(circle at top left, rgba(22, 163, 74, 0.12), transparent 24%),
      linear-gradient(180deg, #edf7f0 0%, #e3f1e7 100%);
  }

  .stockform-panel,
  .stockform-table-panel {
    background: rgba(255, 255, 255, 0.94) !important;
    border: 1px solid rgba(148, 163, 184, 0.18);
    border-radius: 24px !important;
    box-shadow: 0 22px 50px rgba(15, 23, 42, 0.08) !important;
    height: 100%;
    overflow: hidden;
  }

  .stockform-title,
  .stockform-table-title {
    font-family: "Bahnschrift", "Arial Narrow", "Segoe UI", sans-serif;
    font-weight: 800;
    letter-spacing: -0.02em;
    color: #12452a;
  }

  .stockform-section label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #4b6b57;
  }

  .stockform-section input,
  .stockform-section select {
    border-radius: 14px !important;
    border: 1px solid #d4dde7 !important;
    background: #fff !important;
    min-height: 42px;
    box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);
  }

  .stockform-section input:focus,
  .stockform-section select:focus {
    outline: none;
    border-color: #16a34a !important;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
  }

  .stockform-section .react-select__control {
    min-height: 42px;
    border-radius: 14px;
    border-color: #d4dde7;
    box-shadow: none;
  }

  .stockform-section .react-select__control--is-focused {
    border-color: #16a34a;
    box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
  }

  .stockform-form-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .stockform-grid-two {
    display: grid;
    grid-template-columns: 1fr 112px;
    gap: 10px;
    align-items: end;
  }

  .stockform-field-card {
    padding: 0;
    border-radius: 0;
    background: #ffffff;
    box-shadow: none;
  }

  .stockform-search-input {
    position: relative;
  }

  .stockform-search-input svg {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }

  .stockform-action-row {
    display: flex;
    gap: 10px;
    justify-content: stretch;
    margin-top: 6px;
  }

  .stockform-action-row > button {
    flex: 1;
  }

  .stockform-primary,
  .stockform-secondary,
  .stockform-icon-btn {
    border: none;
    border-radius: 14px !important;
    font-weight: 700;
    transition: transform 0.18s ease, opacity 0.18s ease;
  }

  .stockform-primary:hover,
  .stockform-secondary:hover,
  .stockform-icon-btn:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }

  .stockform-records-table thead tr:first-child {
    background: linear-gradient(180deg, #f3fbf5 0%, #e7f5ea 100%) !important;
  }

  .stockform-records-table th {
    font-family: "Bahnschrift", "Arial Narrow", "Segoe UI", sans-serif;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: #4f6a58;
    font-weight: 800;
  }

  .stockform-records-table td,
  .stockform-records-table th {
    border-color: #e7edf3 !important;
  }

  .stockform-records-table td {
    font-family: "Calibri", "Arial Nova", "Segoe UI", sans-serif;
    color: #1f3147;
  }

  .stockform-records-table tbody tr:nth-child(even) {
    background: #fbfdff;
  }

  .stockform-records-table tbody tr:hover {
    background: #f3f9f7;
  }

  .stockform-records-table tbody tr {
    transition: background 0.18s ease;
  }

  .stockform-records-table .records-primary-cell {
    font-weight: 700;
    color: #102033;
  }

  .stockform-records-table .records-docno {
    font-family: "Bahnschrift", "Arial Narrow", "Segoe UI", sans-serif;
    font-weight: 700;
    color: #15803d;
    letter-spacing: 0.02em;
  }

  .stockform-records-table .records-qty {
    font-weight: 700;
    color: #0f172a;
  }

  .stockform-records-table .records-location {
    color: #44614d;
  }

  .stockform-action-wrap {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .stockform-table-panel {
    display: flex;
    flex-direction: column;
  }

  .stockform-logout-btn {
    border: 1px solid #bbf7d0 !important;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%) !important;
    color: #166534 !important;
    border-radius: 14px !important;
    padding: 10px 14px !important;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-family: "Bahnschrift", "Arial Narrow", "Segoe UI", sans-serif;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 10px 18px rgba(22, 163, 74, 0.10);
    transition: transform 0.18s ease, opacity 0.18s ease;
  }

  .stockform-logout-btn:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }

  .stockform-table-card {
    flex: 1;
    min-height: 0;
  }

  .stockform-table-action {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.18s ease, opacity 0.18s ease;
  }

  .stockform-table-action:hover {
    transform: translateY(-1px);
    opacity: 0.94;
  }

  .stockform-table-action.edit {
    background: linear-gradient(135deg, #16a34a, #15803d);
    color: white;
    box-shadow: 0 10px 18px rgba(22, 163, 74, 0.2);
  }

  .stockform-table-action.delete {
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    box-shadow: 0 10px 18px rgba(239, 68, 68, 0.18);
  }

  @media (max-width: 768px) {
    .stockform-shell {
      height: auto;
      min-height: calc(100vh - 16px);
      overflow: visible;
      padding: 0 0 10px;
    }

    .stockform-grid-two {
      grid-template-columns: 1fr;
    }

    .stockform-action-row {
      flex-direction: column;
    }
  }
`}</style>
{isLoading && (
  <div style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 3000 }}>
    <LoadingWave />
  </div>
)}
 <div
  className="stockform-panel stockform-section"
  style={{
    width: isDesktop ? "320px" : "100%",
    flexShrink: 0,
    height: isDesktop ? "100%" : "auto",
    background: "#fff",
    borderRadius: "10px",
    padding: isDesktop ? "18px" : "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
    position: "relative", // important for absolute close button
  }}
>



  {/* CLOSE BUTTON FOR STOCKENTRY */}
  {role === "stockEntry" && (
    <button
      onClick={() => {
        setIsStockFormOpen(false);  // <- close the form
      resetForm();
      }}
      className="stockform-icon-btn"
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        width: "30px",
        height: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        border: "1px solid #ccc",
        background: "#f3f4f6",
        color: "#374151",
        fontSize: "16px",
        cursor: "pointer",
        padding: 0,
        zIndex: 2000,
      }}
      title="Close"
    >
      <FaTimes />
    </button>
  )}

  <h2 className="stockform-title" style={{ textAlign: "left", marginBottom: "10px", fontSize: "18px" }}>
    Stock Entry
  </h2>

      <div
    className="stockform-section"
    style={{
      flex: 1,
      width: "100%",
      minHeight: 0,
      overflowX: "auto", // allow horizontal scroll on mobile
      background: "#fff",
      borderRadius: "0px",
      padding: "0px",
      boxShadow: "none",
      boxSizing: "border-box",
    }}
  >
  <div className="stockform-form-body">
       {/* Date + DocNo row */}
<div className="stockform-grid-two">
  <div className="stockform-field-card" style={{ flex: 1 }}>
    <label>Date:</label>
    <input
      type="date"
      name="date"
      value={formData.date}
      onChange={handleChange}
      required
      style={{
        width: "100%",
        padding: "8px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        boxSizing: "border-box",
      }}
    />
  </div>

  <div className="stockform-field-card" style={{ width: "100%", display: "flex", flexDirection: "column" }}>
    <label>Doc No:</label>
    <input
  type="text"
  value={docNo}
  readOnly
  className="docno-box"
  style={{
    padding: "6px 10px",
    fontSize: "16px",
    background: "#f5f5f5",
    border: "1px solid #ccc",
    borderRadius: "6px",
  }}
/>
  </div>
</div>


{/* Code & Item */}
<div className="stockform-field-card">
  <label>Code & Item:</label>

{/* DESKTOP VIEW → INPUT + SEARCH POPUP */}
{isDesktop ? (
  <div className="stockform-search-input">
    <input
      type="text"
      name="code"
      value={
        formData.code && formData.itemName
          ? `${formData.code} - ${formData.itemName}`
          : ""
      }
      placeholder="Click here to search..."
      readOnly
      onClick={() => setIsPopupOpen(true)} // <-- Add this line
      style={{
        width: "100%",
        padding: "8px 35px 8px 8px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        cursor: "pointer",
        boxSizing: "border-box",
      }}
    />

    <FaSearch
      onClick={() => setIsPopupOpen(true)} // already existing
      style={{
        position: "absolute",
        right: "8px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#666",
        cursor: "pointer",
      }}
    />
  </div>
  ) : (
   <div className="stockform-search-input" style={{ marginTop: "4px" }}>

  {/* MOBILE VIEW → SEARCH INPUT */}
  <input
  id="mobile-item-input"
  type="text"
  placeholder="Search Code or Item..."
  value={searchText}
  onFocus={() => {
    setIsDropdownOpen(true);
    setFilteredItems(items);
  }}
  onChange={(e) => {
    const value = e.target.value;
    setSearchText(value);
    setFilteredItems(
      items.filter((item) =>
        item.CODE.toLowerCase().includes(value.toLowerCase()) ||
        item.DESCRIPTION.toLowerCase().includes(value.toLowerCase())
      )
    );
  }}
  style={{
    width: "100%",
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "14px",
    boxSizing: "border-box",
  }}
/>


  {/* DROPDOWN LIST */}
 {isDropdownOpen && filteredItems.length > 0 && items.length > 0 && (
  <div
    id="mobile-item-dropdown"
    style={{
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      background: "#fff",
      border: "1px solid #ccc",
      borderRadius: "0 0 6px 6px",
      maxHeight: "200px",
      overflowY: "auto",
      zIndex: 200,
    }}
  >

      {filteredItems.map((item) => (
        <div
          key={item.CODE}
          onClick={() => {
            setFormData((prev) => ({
              ...prev,
              code: item.CODE,
              itemName: item.DESCRIPTION,
            }));

            // SHOW SELECTED VALUE INSIDE INPUT
            setSearchText(item.CODE + " - " + item.DESCRIPTION);

            fetchUnits(item.CODE);

            setIsDropdownOpen(false);  // close dropdown
          }}
          style={{
            padding: "8px",
            cursor: "pointer",
            borderBottom: "1px solid #eee",
          }}
        >
          {item.CODE} - {item.DESCRIPTION}
        </div>
      ))}
    </div>
  )}
</div>

  )}
  {/* DESKTOP POPUP ONLY */}
  {isDesktop && isPopupOpen && (
    <>
      <div
        className="popup-overlay"
        onClick={() => setIsPopupOpen(false)}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 999,
        }}
      />

      <div
        className="popup-box"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "600px",
          maxHeight: "80vh",
          background: "#fff",
          border: "1px solid #ccc",
          borderRadius: "10px",
          zIndex: 1000,
          padding: "25px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          overflowY: "auto",
        }}
      >
        {/* SEARCH BAR */}
        <div style={{ display: "flex", marginBottom: "15px" }}>
          <input
            type="text"
            placeholder="Search code or item..."
            value={searchText}
            onChange={(e) => {
              const value = e.target.value;
              setSearchText(value);

              const filtered = items.filter((item) =>
                item.CODE.toLowerCase().includes(value.toLowerCase()) ||
                item.DESCRIPTION.toLowerCase().includes(value.toLowerCase())
              );

              setFilteredItems(filtered);
            }}
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "6px 0 0 6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />

          <button
            type="button"
            onClick={() => {
              const filtered = items.filter((item) =>
                item.CODE.toLowerCase().includes(searchText.toLowerCase()) ||
                item.DESCRIPTION.toLowerCase().includes(searchText.toLowerCase())
              );

              setFilteredItems(filtered);
            }}
            style={{
              padding: "10px 16px",
              border: "1px solid #ccc",
              borderLeft: "none",
              background: "#4f46e5",
              color: "white",
              borderRadius: "0 6px 6px 0",
              cursor: "pointer",
              fontSize: "14px",
            }}
          >
            Search
          </button>
        </div>

        {/* LIST */}
        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            border: "1px solid #eee",
            borderRadius: "6px",
          }}
        >
          {filteredItems.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                color: "#888",
                padding: "10px",
                fontSize: "14px",
              }}
            >
              No items found
            </p>
          ) : (
            filteredItems.map((item, index) => (
              <div
                key={item.CODE}
                onClick={() => {
                  setFormData((prev) => ({
                    ...prev,
                    code: item.CODE,
                    itemName: item.DESCRIPTION,
                  }));

                  fetchUnits(item.CODE);
                  setIsPopupOpen(false);
                }}
                style={{
                  padding: "10px",
                  cursor: "pointer",
                  borderBottom:
                    index !== filteredItems.length - 1
                      ? "1px solid #eee"
                      : "none",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = "#f3f4f6")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "#fff")
                }
              >
                {item.CODE} - {item.DESCRIPTION}
              </div>
            ))
          )}
        </div>

        {/* CLOSE BUTTON */}
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <button
            onClick={() => setIsPopupOpen(false)}
            style={{
              padding: "6px 12px",
              background: "#e5e7eb",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>
      </div>
    </>
  )}
</div>


     {/* Unit */}
<div className="stockform-field-card" style={{ width: "100%", maxWidth: "100%", boxSizing: "border-box", position: "relative" }}>
  <label>Unit:</label>
  <select
    name="unit"
    value={formData.unit}
    onChange={handleChange}
    style={{
      display: "block",
      width: "100%",
      maxWidth: "100%",
      padding: "8px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      boxSizing: "border-box",
      WebkitAppearance: "menulist-button",
      appearance: "menulist-button",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    }}
  >
    <option value="">Select Unit</option>
    {units.map((u) => (
      <option key={u.unit_docno} value={u.unit_docno}>
        {u.unit_docno}
      </option>
    ))}
  </select>
</div>
{/* From Location */}
<div className="stockform-field-card">
  <label>From Location:</label>

  <Select
    classNamePrefix="react-select"
    options={locations}
    value={formData.fromLocation || null}   // directly use selected object
    onChange={(selected) =>
      setFormData((prev) => ({
        ...prev,
        fromLocation: selected   // store full object {value,label}
      }))
    }
    placeholder="Select location"
  />
</div>

{/* To Location */}
<div className="stockform-field-card">
  <label>To Location:</label>

  <Select
    classNamePrefix="react-select"
    options={locations}
    value={formData.toLocation || null}
    onChange={(selected) =>
      setFormData((prev) => ({
        ...prev,
        toLocation: selected
      }))
    }
    placeholder="Select location"
    isDisabled={locations.length === 0}
  />
</div>



          
        {/* Quantity */}
        <div className="stockform-field-card">
          <label>Quantity:</label>
          <input
            type="number"
            name="quantity"
            value={formData.quantity}
            onChange={handleChange}
            required
            min="1"
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "6px",
              border: "1px solid #ccc",
            }}
          />
        </div>

  {/* Submit */}
<div className="stockform-action-row">
  <button
    className="stockform-primary"
    type="button"
    onClick={isEditing ? handleUpdateSubmit : handleTransferSubmit}
    style={{
      padding: "12px 20px",
      borderRadius: "8px",
      background: "linear-gradient(135deg, #16a34a, #15803d)",
      color: "#ffffff",
      border: "none",
      fontWeight: "bold",
      cursor: "pointer",
    }}
  >
    {isEditing ? "Update Stock" : "Add Stock"}
  </button>

  <button
    className="stockform-secondary"
    type="button"
    onClick={resetForm}
    style={{
      padding: "12px 20px",
      borderRadius: "8px",
      background: "#f1fbf4",
      color: "#166534",
      border: "1px solid #bbf7d0",
      fontWeight: "bold",
      cursor: "pointer",
    }}
  >
    Reset
  </button>
</div>
</div>

      </div>




      {showAddButton && (
        <button
          onClick={() => {
            setIsEditing(false);
            setEditingId(null);
            setShowAddButton(false);
            setFormData({
              date: new Date().toISOString().slice(0, 10),
              code: "",
              itemName: "",
              unit: "",
              fromLocation: "",
              toLocation: "",
              quantity: "",
            });
          }}
          style={{
            padding: "8px 16px",
            background: "#f8fffcff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            marginTop: "12px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
         
        </button>
      )}
      

    </div>
    {/* TITLE OUTSIDE, ABOVE, LEFT */}
{/* TABLE */}
<div
  className="stockform-table-panel"
  style={{
    flex: 1,
    width: "100%",
    minHeight: 0,
    background: "#fff",
    borderRadius: "10px",
    padding: "14px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
  }}
>
  {/* Header with Stock Records on left and Logout on right */}
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px", flexShrink: 0 }}>
    <h4
      className="stockform-table-title"
      style={{
        margin: 0,
        fontSize: "20px",
        fontWeight: "700",
      }}
    >
      Stock Records
    </h4>
    
    <button
      onClick={handleLogout}
      className="stockform-logout-btn"
      title="Logout"
    >
      <FiLogOut />
      Logout
    </button>
  </div>

  {entries.length === 0 ? (
    <p style={{ textAlign: "center", color: "#888" }}>No stock entries yet.</p>
  ) : (
    <div
      className="stockform-table-card"
      style={{
        overflowY: "auto", // table scroll
        maxHeight: "100%",
        borderRadius: "6px",
        border: "1px solid #ddd",
      }}
    >
      <table
        className="stockform-records-table"
        style={{
          width: "100%",
          minWidth: isDesktop ? "1100px" : "0",
          borderCollapse: "collapse",
          fontSize: isDesktop ? "13px" : "12px",
          fontFamily: "'Calibri', 'Arial Nova', 'Segoe UI', sans-serif",
        }}
      >
    <thead>
      {/* Header Row */}
      <tr style={{ background: "#f3f4f6", textAlign: "left" }}>
        <th style={{ width: "30px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>Date</th>
        <th style={{ width: "80px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>DocNo</th>
        <th style={{ width: "80px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>Code</th>
        <th style={{ width: "300px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>Item Name</th>
        <th style={{ width: "60px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>Quantity</th>
        <th style={{ width: "60px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>Unit</th>
        <th style={{ width: "110px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>From</th>
        <th style={{ width: "110px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>To</th>
        <th style={{ width: "80px", border: "1px solid #e5e7eb", padding: "8px", position: "sticky", top: 0, background: "#f3f4f6", zIndex: 2 }}>Actions</th>
      </tr>

      {/* Search Row */}
      <tr style={{ background: "#f9fafb" }}>
        <th style={{ border: "1px solid #e5e7eb", padding: "4px", position: "sticky", top: "40px", background: "#f9fafb", zIndex: 1 }}>
          <input
            type="date"
            value={searchDate}
            onChange={(e) => setSearchDate(e.target.value)}
            style={{ width: "100%", padding: "4px", fontSize: "12px" }}
          />
        </th>
        <th style={{ border: "1px solid #e5e7eb", padding: "4px", position: "sticky", top: "40px", background: "#f9fafb", zIndex: 1 }}>
          <input
            placeholder="Search DocNo"
            value={searchDoc}
            onChange={(e) => setSearchDoc(e.target.value)}
            style={{ width: "100%", padding: "4px", fontSize: "12px" }}
          />
        </th>
        <th style={{ border: "1px solid #e5e7eb", padding: "4px", position: "sticky", top: "40px", background: "#f9fafb", zIndex: 1 }}>
          <input
            placeholder="Search Code"
            value={searchCode}
            onChange={(e) => setSearchCode(e.target.value)}
            style={{ width: "100%", padding: "4px", fontSize: "12px" }}
          />
        </th>
        <th style={{ border: "1px solid #e5e7eb", padding: "4px", position: "sticky", top: "40px", background: "#f9fafb", zIndex: 1 }}>
          <input
            placeholder="Search Item"
            value={searchItem}
            onChange={(e) => setSearchItem(e.target.value)}
            style={{ width: "100%", padding: "4px", fontSize: "12px" }}
          />
        </th>
        <th colSpan="5" style={{ border: "1px solid #e5e7eb", padding: "4px", position: "sticky", top: "40px", background: "#f9fafb", zIndex: 1 }}></th>
      </tr>
    </thead>

    <tbody>
      {currentEntries.map((entry, index) => (
        <tr key={`${entry.docNo}_${entry.code}_${index}`}>
          <td className="records-primary-cell" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>{entry.date?.split("T")[0]}</td>
          <td className="records-docno" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>{entry.docNo}</td>
          <td className="records-primary-cell" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>{entry.code}</td>
          <td className="records-primary-cell" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>{entry.itemName}</td>
          <td className="records-qty" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>{entry.quantity}</td>
          <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>{entry.unit}</td>
          <td className="records-location" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>
  {getLocationLabel(entry.fromLocation)}
</td>

<td className="records-location" style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>
  {getLocationLabel(entry.toLocation)}
</td>
          <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px" }}>
            <div className="stockform-action-wrap">
              <button className="stockform-table-action edit" onClick={() => onEditClick(entry)} style={{ border: "none", cursor: "pointer" }}>
                <FaEdit size={14} />
              </button>
              <button className="stockform-table-action delete" onClick={() => handleTableDelete(entry.docNo)} style={{ border: "none", cursor: "pointer" }}>
                <FaTrash size={14} />
              </button>

  

            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
<div style={{ marginTop: "10px", textAlign: "center", fontSize: "14px" }}>
  {/* LOGOUT BUTTON — FIXED BOTTOM LEFT */}



  {(() => {
    const pages = [];
    const visibleCount = 5; // number of pages to show in the sliding window
    const lastPage = totalPages;
    const step = 5; // number of pages to move when clicking arrow

    // calculate start page for sliding window
    let startPage = currentPage;
    if (currentPage + visibleCount - 1 > lastPage) {
      startPage = Math.max(1, lastPage - visibleCount + 1);
    }

    // Add back arrow << if startPage > 1
    if (startPage > 1) {
      pages.push(
        <span
          key="prev"
          onClick={() => setCurrentPage(Math.max(1, startPage - step))}
          style={{ cursor: "pointer", margin: "0 6px" }}
        >
          &lt;&lt;
        </span>
      );
    }

    // Add visible page numbers
    for (let i = startPage; i < startPage + visibleCount && i <= lastPage; i++) {
      pages.push(
        <span
          key={i}
          onClick={() => setCurrentPage(i)}
          style={{
            cursor: "pointer",
            margin: "0 4px",
            fontWeight: currentPage === i ? "bold" : "normal",
            textDecoration: currentPage === i ? "underline" : "none",
          }}
        >
          {i}
        </span>
      );
    }

    // Add dots + last page if there are more pages
    if (startPage + visibleCount - 1 < lastPage) {
      pages.push(
        <span key="dots" style={{ margin: "0 4px" }}>
          ...
        </span>
      );
      pages.push(
        <span
          key={lastPage}
          onClick={() => setCurrentPage(lastPage)}
          style={{
            cursor: "pointer",
            margin: "0 4px",
            fontWeight: currentPage === lastPage ? "bold" : "normal",
            textDecoration: currentPage === lastPage ? "underline" : "none",
          }}
        >
          {lastPage}
        </span>
      );
    }

    // Add forward arrow >> if there are more pages after the visible window
    if (startPage + visibleCount - 1 < lastPage) {
      pages.push(
        <span
          key="next"
          onClick={() => setCurrentPage(Math.min(lastPage, startPage + step))}
          style={{ cursor: "pointer", margin: "0 6px" }}
        >
          &gt;&gt;
        </span>
      );
    }

    return pages;

    
  })()}
</div>

  


</div>
 )}
</div>
</div>
  );
}
